<template>
    <div class="flex gap-6 py-8 ">
        <a href="#link" class="cb-text-copy-small btn-link no-underline">Help Documentation</a>
        <a href="#link" class="cb-text-copy-small btn-link no-underline">Support</a>
        <a href="#link" class="cb-text-copy-small btn-link no-underline">Legal & Privacy Policy</a>
    </div>
</template>